import axios from 'axios';
import { API_URL } from '../config/apiConfig';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Get all room fields for the organization
export const getRoomFields = async () => {
  try {
    const response = await api.get('/api/room-fields');
    return response.data.fields;
  } catch (error) {
    console.error('Error fetching room fields:', error);
    throw error;
  }
};

// Initialize system fields for the organization
export const initializeSystemFields = async () => {
  try {
    const response = await api.post('/api/room-fields/initialize');
    return response.data;
  } catch (error) {
    console.error('Error initializing system fields:', error);
    throw error;
  }
};

// Create a new room field
export const createRoomField = async (fieldData) => {
  try {
    const response = await api.post('/api/room-fields', fieldData);
    return response.data;
  } catch (error) {
    console.error('Error creating room field:', error);
    throw error;
  }
};

// Update a room field
export const updateRoomField = async (fieldId, fieldData) => {
  try {
    const response = await api.put(`/api/room-fields/${fieldId}`, fieldData);
    return response.data;
  } catch (error) {
    console.error('Error updating room field:', error);
    throw error;
  }
};

// Reorder room fields
export const reorderRoomFields = async (fieldIds) => {
  try {
    const response = await api.put('/api/room-fields/reorder', { fieldIds });
    return response.data;
  } catch (error) {
    console.error('Error reordering room fields:', error);
    throw error;
  }
};

// Delete a room field
export const deleteRoomField = async (fieldId) => {
  try {
    const response = await api.delete(`/api/room-fields/${fieldId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting room field:', error);
    throw error;
  }
};

const roomFieldService = {
  getRoomFields,
  initializeSystemFields,
  createRoomField,
  updateRoomField,
  reorderRoomFields,
  deleteRoomField,
};

export default roomFieldService; 